var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false}},[_vm._v("الطلبات")]),_c('main-table',{attrs:{"baseURL":_vm.SFZ_API_LINK,"fields":_vm.fields,"list_url":"admin/orders"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }